import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCursor1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cursor-1, arrow"><path d="M5.66105 2.79854C3.88702 2.18542 2.1864 3.88605 2.79952 5.66008L7.92593 20.4931C8.6032 22.4528 11.3457 22.5311 12.1337 20.6133L14.4843 14.892C14.5605 14.7067 14.7077 14.5595 14.893 14.4833L20.6142 12.1327C22.5321 11.3447 22.4538 8.60222 20.4941 7.92495L5.66105 2.79854Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCursor1;
